/* eslint-disable */
export default {
  noActiveCalls: 'アクティブな通話はありません',
  currentCall: '現在の通話',
  ringCall: '呼び出し中の通話',
  onHoldCall: '保留中の通話',
  otherDeviceCall: '他のデバイスで進行中の通話',
  confirmation: '確認',
  confirmMergeToConference: '電話会議に追加しますか?',
  mergeToConference: 'マージ',
  conferenceCall: '電話会議',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
